import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n-lite';

/**
 * Class code inside a mobile sheet: label, code, how students use it and a copy button.
 * Used by the class header ⋮ (ClassMoreSheet) and by the home card class code (ClassCodeReveal).
 */
const ClassCodeBlock = ({ classCode, onCodeCopied }) => {
  const copyCode = () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(classCode).then(onCodeCopied, () => undefined);
    }
  };

  return (
    <div className="class-sheet-code">
      <span className="class-sheet-code-label">{I18n.t('leftMenu.classcode')}</span>
      <span className="class-sheet-code-value">{classCode}</span>
      <span className="class-sheet-code-info">
        {I18n.t('classCodePopup.info1')} {I18n.t('classCodePopup.info2')}
      </span>
      <button type="button" className="class-sheet-code-copy" onClick={copyCode}>
        <i className="custom-icons-copy-file" aria-hidden="true" />
        {I18n.t('mobileSheets.copyCode')}
      </button>
    </div>
  );
};

ClassCodeBlock.propTypes = {
  classCode: PropTypes.string,
  onCodeCopied: PropTypes.func
};

export default ClassCodeBlock;
